module.exports = __webpack_public_path__ + "static/media/cinesuede.55e13483.png";